import auth from "./auth";
import client from "./wrapper";

export default { auth, client };
